var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7039 10.4686C11.4724 9.53636 11.934 8.34171 11.934 7.03925C11.934 4.05983 9.51867 1.64453 6.53925 1.64453C3.55983 1.64453 1.14453 4.05983 1.14453 7.03925C1.14453 10.0187 3.55983 12.434 6.53925 12.434C7.84171 12.434 9.03636 11.9724 9.96856 11.2039L13.9712 15.2065C14.1742 15.4096 14.5035 15.4096 14.7065 15.2065C14.9096 15.0035 14.9096 14.6742 14.7065 14.4712L10.7039 10.4686ZM6.53925 11.394C4.13418 11.394 2.18448 9.44432 2.18448 7.03925C2.18448 4.63418 4.13418 2.68448 6.53925 2.68448C8.94432 2.68448 10.894 4.63418 10.894 7.03925C10.894 9.44432 8.94432 11.394 6.53925 11.394Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.db373d8da8cc9d3246c77386c201e6a2.svg";
export { ForwardRef as ReactComponent };